import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Assignment } from '../../interfaces/assignment';
import { DataService } from '../../services/data.service';
import { environment } from 'src/environments/environment';

const oneDayMiliseconds = 1000 * 60 * 60 * 24;

@Component({
  selector: 'app-widget-assignments',
  templateUrl: './widget-assignments.component.html',
  styleUrls: ['./widget-assignments.component.scss']
})
export class WidgetAssignmentsComponent implements OnInit {
  @Input({ required: true }) widgetData!: any;
  @Output() widgetLoaded: EventEmitter<any> = new EventEmitter<any>();

  mockAssignment: Assignment = {
    title: "",
    date: ""
  }
  
  assignments: Assignment[] = [];
  displayedColumns: string[] = ['text', 'date', 'state'];
  loading: boolean = false;
  isServerError: boolean = false;

  constructor(private dataService: DataService) { }

  ngOnInit(): void {
    this.assignments = Array.from({ length: this.widgetData.maxDisplayItems }, () => (this.mockAssignment));
    this.getData();
  }

  getData() {
    this.loading = true;
    let url = environment.apiUrl + '/Portal/Api/Widgets/GetAssignmentsForWidget';
    let request: any = {
      cultureCode: this.dataService.getCultureCode(),
      maxDisplayItems: this.widgetData.maxDisplayItems,
      postExpirationDisplayDuration: this.widgetData.postExpirationDisplayDuration,
      maxDisplaySubmitDayCount: this.widgetData.maxDisplaySubmitDayCount
    };
    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData) => {
        this.assignments = responseData;
        this.widgetLoaded.emit({ exists: true, count: this.assignments.length, title: this.widgetData.title, loading: false  });
        this.loading = false;
      },
      error: (e: any) => {
        console.error(e);
        this.loading = false;
        this.isServerError = true;
      }
    });
  }
}
